import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";

export default class CreatorPaymentInformation extends Model {
    static entity = 'creator_payment_information';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            creator_id: this.uid(),
            name: this.string(null).nullable(),
            email: this.string(null).nullable(),
            paypalme_link: this.string(null).nullable(),
            wise_type: this.string(null).nullable(),
            wise_account: this.string(null).nullable(),
            swift: this.string(null).nullable(),
            iban: this.string(null).nullable(),
            bank_name: this.string(null).nullable(),
            bank_account: this.string(null).nullable(),
            bank_address: this.string(null).nullable(),
            account_number: this.string(null).nullable(),
            account_address: this.string(null).nullable(),
            industry_code: this.string(null).nullable(),
            text: this.string(null).nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare creator_id: number;
    declare name: string | null;
    declare email: string | null;
    declare paypalme_link: string | null;
    declare wise_type: string | null;
    declare wise_account: string | null;
    declare swift: string | null;
    declare iban: string | null;
    declare bank_name: string | null;
    declare bank_account: string | null;
    declare bank_address: string | null;
    declare account_number: string | null;
    declare account_address: string | null;
    declare industry_code: string | null;
    declare text: string | null;
}
